"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var _utils = require("../../../common/utils/utils");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _selector = require("./selector");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* addItemToCart(params) {
  try {
    yield (0, _effects.put)(actions.ADD_TO_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addToCart, params, tokenData);
    yield (0, _effects.put)(actions.ADD_TO_CART_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_TO_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateProductQuantity(params) {
  try {
    yield (0, _effects.put)(actions.UPDATE_PRODUCT_QUANTITY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateProductQuantity, params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_PRODUCT_QUANTITY_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_PRODUCT_QUANTITY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCartInfo(params) {
  try {
    var _params$data, _params$data2;
    yield (0, _effects.put)(actions.GET_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartInfo, params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.param, tokenData);
    yield (0, _effects.put)(actions.GET_CART_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data2 = params.data) !== null && _params$data2 !== void 0 && _params$data2.onSuccess) {
      var _mainResponse$data;
      params.data.onSuccess((_mainResponse$data = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data !== void 0 ? _mainResponse$data : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data3;
    yield (0, _effects.put)(actions.GET_CART_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data3 = params.data) !== null && _params$data3 !== void 0 && _params$data3.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getTopSellingProducts(params) {
  try {
    var _params$data4, _params$data5;
    yield (0, _effects.put)(actions.GET_TOP_SELLING_PRODUCT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getTopSellingProducts, params === null || params === void 0 || (_params$data4 = params.data) === null || _params$data4 === void 0 ? void 0 : _params$data4.params, tokenData);
    yield (0, _effects.put)(actions.GET_TOP_SELLING_PRODUCT_API.success(mainResponse));
    if (params !== null && params !== void 0 && params.data && params !== null && params !== void 0 && (_params$data5 = params.data) !== null && _params$data5 !== void 0 && _params$data5.onSuccess) {
      var _mainResponse$data$pr, _mainResponse$data2;
      params.data.onSuccess((_mainResponse$data$pr = mainResponse === null || mainResponse === void 0 || (_mainResponse$data2 = mainResponse.data) === null || _mainResponse$data2 === void 0 ? void 0 : _mainResponse$data2.productList) !== null && _mainResponse$data$pr !== void 0 ? _mainResponse$data$pr : []);
    }
    return mainResponse;
  } catch (err) {
    var _params$data6;
    yield (0, _effects.put)(actions.GET_TOP_SELLING_PRODUCT_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data6 = params.data) !== null && _params$data6 !== void 0 && _params$data6.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteProducts(request) {
  try {
    var _request$data, _request$data2;
    yield (0, _effects.put)(actions.DELETE_ITEMS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteProducts, request === null || request === void 0 || (_request$data = request.data) === null || _request$data === void 0 ? void 0 : _request$data.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_ITEMS_API.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data2 = request.data) !== null && _request$data2 !== void 0 && _request$data2.onSuccess) {
      var _mainResponse$data3;
      request.data.onSuccess((_mainResponse$data3 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data3 !== void 0 ? _mainResponse$data3 : {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data3;
    yield (0, _effects.put)(actions.DELETE_ITEMS_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data3 = request.data) !== null && _request$data3 !== void 0 && _request$data3.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* cartProductsRecommendation(params) {
  try {
    yield (0, _effects.put)(actions.CART_PRODUCTS_RECOMMENDATION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cartProductsRecommendation, params.data.params.pageSize, params.data.params.pageFrom, tokenData);
    yield (0, _effects.put)(actions.CART_PRODUCTS_RECOMMENDATION_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    var _params$data7;
    yield (0, _effects.put)(actions.CART_PRODUCTS_RECOMMENDATION_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data7 = params.data) !== null && _params$data7 !== void 0 && _params$data7.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* addItemToCartV2(params) {
  try {
    const cartOperations = yield (0, _effects.select)((0, _selector.cartOperationSelector)());
    const cartCount = cartOperations.add_to_cart_count;
    yield (0, _effects.put)({
      type: actions.SET_CART_OPERATION_DATA,
      data: {
        add_to_cart_count: cartCount + 1
      }
    });
    yield (0, _effects.put)(actions.ADD_TO_CART_API_V2.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addToCartV2, params, tokenData);
    yield (0, _effects.put)(actions.ADD_TO_CART_API_V2.success(mainResponse));
    const cartOperationsUpdated = yield (0, _effects.select)((0, _selector.cartOperationSelector)());
    const cartCountUpdated = cartOperationsUpdated.add_to_cart_count;
    if (cartCountUpdated > 0) {
      yield (0, _effects.put)({
        type: actions.SET_CART_OPERATION_DATA,
        data: {
          add_to_cart_count: cartCountUpdated - 1
        }
      });
    }
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_TO_CART_API_V2.failure(err));
    const cartOperationsUpdated = yield (0, _effects.select)((0, _selector.cartOperationSelector)());
    const cartCountUpdated = cartOperationsUpdated.add_to_cart_count;
    if (cartCountUpdated > 0) {
      yield (0, _effects.put)({
        type: actions.SET_CART_OPERATION_DATA,
        data: {
          add_to_cart_count: cartCountUpdated - 1
        }
      });
    }
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateProductQuantityV2(params) {
  try {
    const cartOperations = yield (0, _effects.select)((0, _selector.cartOperationSelector)());
    const cartCount = cartOperations.update_to_cart_count;
    yield (0, _effects.put)({
      type: actions.SET_CART_OPERATION_DATA,
      data: {
        update_to_cart_count: cartCount + 1
      }
    });
    yield (0, _effects.put)(actions.UPDATE_PRODUCT_QUANTITY_API_V2.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateProductQuantityV2, params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_PRODUCT_QUANTITY_API_V2.success(mainResponse));
    const cartOperationsUpdated = yield (0, _effects.select)((0, _selector.cartOperationSelector)());
    const cartCountUpdated = cartOperationsUpdated.update_to_cart_count;
    if (cartCountUpdated > 0) {
      yield (0, _effects.put)({
        type: actions.SET_CART_OPERATION_DATA,
        data: {
          update_to_cart_count: cartCountUpdated - 1
        }
      });
    }
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_PRODUCT_QUANTITY_API_V2.failure(err));
    const cartOperationsUpdated = yield (0, _effects.select)((0, _selector.cartOperationSelector)());
    const cartCountUpdated = cartOperationsUpdated.update_to_cart_count;
    if (cartCountUpdated > 0) {
      yield (0, _effects.put)({
        type: actions.SET_CART_OPERATION_DATA,
        data: {
          update_to_cart_count: cartCountUpdated - 1
        }
      });
    }
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteProductsV2(request) {
  try {
    var _request$data4, _request$data5;
    yield (0, _effects.put)(actions.DELETE_ITEMS_API_V2.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteProductsV2, request === null || request === void 0 || (_request$data4 = request.data) === null || _request$data4 === void 0 ? void 0 : _request$data4.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_ITEMS_API_V2.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data5 = request.data) !== null && _request$data5 !== void 0 && _request$data5.onSuccess) {
      var _mainResponse$data4;
      request.data.onSuccess((_mainResponse$data4 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data4 !== void 0 ? _mainResponse$data4 : {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data6;
    yield (0, _effects.put)(actions.DELETE_ITEMS_API_V2.failure(err));
    if (request !== null && request !== void 0 && (_request$data6 = request.data) !== null && _request$data6 !== void 0 && _request$data6.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getCartInfoV2(params) {
  try {
    var _params$data8, _params$data9, _params$data10;
    if (params !== null && params !== void 0 && (_params$data8 = params.data) !== null && _params$data8 !== void 0 && (_params$data8 = _params$data8.param) !== null && _params$data8 !== void 0 && _params$data8.isShowLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.GET_CART_API_V2.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartInfoV2, params === null || params === void 0 || (_params$data9 = params.data) === null || _params$data9 === void 0 ? void 0 : _params$data9.param, tokenData);
    yield (0, _effects.put)(actions.GET_CART_API_V2.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data10 = params.data) !== null && _params$data10 !== void 0 && _params$data10.onSuccess) {
      var _mainResponse$data5;
      params.data.onSuccess((_mainResponse$data5 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data5 !== void 0 ? _mainResponse$data5 : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data11;
    yield (0, _effects.put)(actions.GET_CART_API_V2.failure(err));
    if (params !== null && params !== void 0 && (_params$data11 = params.data) !== null && _params$data11 !== void 0 && _params$data11.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* addFBTToCart(request) {
  try {
    var _request$data7, _request$data8;
    yield (0, _effects.put)(actions.FBT_ADD_TO_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.FBTAddToCart, request === null || request === void 0 || (_request$data7 = request.data) === null || _request$data7 === void 0 ? void 0 : _request$data7.params, tokenData);
    yield (0, _effects.put)(actions.FBT_ADD_TO_CART_API.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data8 = request.data) !== null && _request$data8 !== void 0 && _request$data8.onSuccess) {
      var _mainResponse$data6;
      request.data.onSuccess((_mainResponse$data6 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data6 !== void 0 ? _mainResponse$data6 : {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data9;
    yield (0, _effects.put)(actions.FBT_ADD_TO_CART_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data9 = request.data) !== null && _request$data9 !== void 0 && _request$data9.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getCartMarketingBanner(params) {
  try {
    var _params$data12;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartMarketingBanners, tokenData);
    yield (0, _effects.put)(actions.GET_CART_MARKETING_BANNER_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data12 = params.data) !== null && _params$data12 !== void 0 && _params$data12.onSuccess) {
      var _mainResponse$data7;
      params.data.onSuccess((_mainResponse$data7 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data7 !== void 0 ? _mainResponse$data7 : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data13;
    yield (0, _effects.put)(actions.GET_CART_MARKETING_BANNER_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data13 = params.data) !== null && _params$data13 !== void 0 && _params$data13.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCartFillers(request) {
  try {
    var _request$data10, _request$data11;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartFillers, request === null || request === void 0 || (_request$data10 = request.data) === null || _request$data10 === void 0 ? void 0 : _request$data10.params, tokenData);
    if (request !== null && request !== void 0 && (_request$data11 = request.data) !== null && _request$data11 !== void 0 && _request$data11.onSuccess) {
      var _mainResponse$body;
      request.data.onSuccess((_mainResponse$body = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body !== void 0 ? _mainResponse$body : {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data12;
    if (request !== null && request !== void 0 && (_request$data12 = request.data) !== null && _request$data12 !== void 0 && _request$data12.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* addONLINEASTERToCart(request) {
  try {
    var _request$data13, _request$data14;
    if (!(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.ASTER_ONLINE_ADD_TO_CART_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.asterOnlineAddToCart, request === null || request === void 0 || (_request$data13 = request.data) === null || _request$data13 === void 0 ? void 0 : _request$data13.params, tokenData);
    yield (0, _effects.put)(actions.ASTER_ONLINE_ADD_TO_CART_API.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data14 = request.data) !== null && _request$data14 !== void 0 && _request$data14.onSuccess) {
      var _mainResponse$data8;
      request.data.onSuccess((_mainResponse$data8 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data8 !== void 0 ? _mainResponse$data8 : {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data15;
    yield (0, _effects.put)(actions.ASTER_ONLINE_ADD_TO_CART_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data15 = request.data) !== null && _request$data15 !== void 0 && _request$data15.onFailure) {
      request.data.onFailure(err);
    }
  }
}

/**
 * New Cart Saga generators for Api which provides merge response of CartInfo and CartInfoDetail
 * **/

function* getCommonServiceCartData(params) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = (params === null || params === void 0 ? void 0 : params.data) || {};
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.GET_COMMON_SERVICE_CART_DATA_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCommonCartAPI, tokenData, requestParams);
    yield (0, _effects.put)(actions.GET_COMMON_SERVICE_CART_DATA_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    var _params$data14;
    yield (0, _effects.put)(actions.GET_COMMON_SERVICE_CART_DATA_API.failure(err));
    params === null || params === void 0 || (_params$data14 = params.data) === null || _params$data14 === void 0 || _params$data14.onFailure(err);
  }
}
function* getCartDetails(params) {
  try {
    var _params$data15, _params$data16, _params$data17;
    if ((0, _utils.isMobile)() && params !== null && params !== void 0 && (_params$data15 = params.data) !== null && _params$data15 !== void 0 && _params$data15.showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.GET_CART_DETAILS_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartDetails, params === null || params === void 0 || (_params$data16 = params.data) === null || _params$data16 === void 0 ? void 0 : _params$data16.param, tokenData);
    yield (0, _effects.put)(actions.GET_CART_DETAILS_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data17 = params.data) !== null && _params$data17 !== void 0 && _params$data17.onSuccess) {
      var _mainResponse$body2;
      params.data.onSuccess((_mainResponse$body2 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body2 !== void 0 ? _mainResponse$body2 : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data18;
    yield (0, _effects.put)(actions.GET_CART_DETAILS_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data18 = params.data) !== null && _params$data18 !== void 0 && _params$data18.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* createRxCart(params) {
  try {
    var _params$data19, _params$data20;
    yield (0, _effects.put)(actions.CREATE_RX_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.createRxCart, params === null || params === void 0 || (_params$data19 = params.data) === null || _params$data19 === void 0 ? void 0 : _params$data19.param, tokenData);
    yield (0, _effects.put)(actions.CREATE_RX_CART_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data20 = params.data) !== null && _params$data20 !== void 0 && _params$data20.onSuccess) {
      var _mainResponse$body3;
      params.data.onSuccess((_mainResponse$body3 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body3 !== void 0 ? _mainResponse$body3 : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data21;
    yield (0, _effects.put)(actions.CREATE_RX_CART_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data21 = params.data) !== null && _params$data21 !== void 0 && _params$data21.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* resetRxCart() {
  try {
    yield (0, _effects.put)(actions.CREATE_RX_CART_API.success({}));
  } catch (err) {
    yield (0, _effects.put)(actions.CREATE_RX_CART_API.success({}));
  }
}
function* addItemsToCart(params) {
  try {
    var _params$data22, _params$data23, _params$data24;
    if (_utils.isMobile && params !== null && params !== void 0 && (_params$data22 = params.data) !== null && _params$data22 !== void 0 && _params$data22.showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.ADD_ITEMS_TO_CART_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addItemsToCart, params, tokenData);
    yield (0, _effects.put)(actions.ADD_ITEMS_TO_CART_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data23 = params.data) !== null && _params$data23 !== void 0 && (_params$data23 = _params$data23.params) !== null && _params$data23 !== void 0 && _params$data23.showCart) {
      yield (0, _effects.put)(actions.GET_CART_DETAILS_API.success(mainResponse));
    }
    if (params !== null && params !== void 0 && params.data && params !== null && params !== void 0 && (_params$data24 = params.data) !== null && _params$data24 !== void 0 && _params$data24.onSuccess) {
      var _mainResponse$body4;
      params.data.onSuccess((_mainResponse$body4 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body4 !== void 0 ? _mainResponse$body4 : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data25;
    yield (0, _effects.put)(actions.ADD_ITEMS_TO_CART_API.failure(err));
    if (params !== null && params !== void 0 && params.data && params !== null && params !== void 0 && (_params$data25 = params.data) !== null && _params$data25 !== void 0 && _params$data25.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateItemsInCart(params) {
  try {
    var _params$data26;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateItemsInCart, params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_ITEMS_IN_CART_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data26 = params.data) !== null && _params$data26 !== void 0 && (_params$data26 = _params$data26.params) !== null && _params$data26 !== void 0 && _params$data26.showCart) {
      yield (0, _effects.put)(actions.GET_CART_DETAILS_API.success(mainResponse));
    }
    if (params.data && params.data.onSuccess) {
      var _mainResponse$body5;
      params.data.onSuccess((_mainResponse$body5 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body5 !== void 0 ? _mainResponse$body5 : {});
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_ITEMS_IN_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* removeItemsFromCart(params) {
  try {
    var _params$data27;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.removeItemFromCart, params, tokenData);
    yield (0, _effects.put)(actions.REMOVE_ITEM_FROM_CART_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data27 = params.data) !== null && _params$data27 !== void 0 && (_params$data27 = _params$data27.params) !== null && _params$data27 !== void 0 && _params$data27.showCart) {
      yield (0, _effects.put)(actions.GET_CART_DETAILS_API.success(mainResponse));
    }
    if (params.data && params.data.onSuccess) {
      var _mainResponse$body6;
      params.data.onSuccess((_mainResponse$body6 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body6 !== void 0 ? _mainResponse$body6 : {});
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REMOVE_ITEM_FROM_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* removeMultipleItemsFromCart(params) {
  try {
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.removeMultipleItemsFromCart, params, tokenData);
    yield (0, _effects.put)(actions.REMOVE_MULTIPLE_ITEMS_FROM_CART_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      var _mainResponse$body7;
      params.data.onSuccess((_mainResponse$body7 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body7 !== void 0 ? _mainResponse$body7 : {});
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REMOVE_MULTIPLE_ITEMS_FROM_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* mergeCartDetails(params) {
  try {
    var _params$data28, _params$data29;
    yield (0, _effects.put)(actions.MERGE_CART_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.mergeCartDetails, params === null || params === void 0 || (_params$data28 = params.data) === null || _params$data28 === void 0 ? void 0 : _params$data28.param, tokenData);
    yield (0, _effects.put)(actions.MERGE_CART_DETAILS_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data29 = params.data) !== null && _params$data29 !== void 0 && _params$data29.onSuccess) {
      var _mainResponse$body8;
      params.data.onSuccess((_mainResponse$body8 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body8 !== void 0 ? _mainResponse$body8 : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data30;
    yield (0, _effects.put)(actions.MERGE_CART_DETAILS_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data30 = params.data) !== null && _params$data30 !== void 0 && _params$data30.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateUserCartData(params) {
  try {
    if (params !== null && params !== void 0 && params.data) {
      yield (0, _effects.put)(actions.GET_CART_DETAILS_API.success(params === null || params === void 0 ? void 0 : params.data));
    }
  } catch (err) {}
}
function* watchers() {
  yield (0, _effects.takeEvery)(actions.ADD_TO_CART, addItemToCart);
  yield (0, _effects.takeEvery)(actions.UPDATE_PRODUCT_QUANTITY, updateProductQuantity);
  yield (0, _effects.takeEvery)(actions.GET_CART, getCartInfo);
  yield (0, _effects.takeLatest)(actions.GET_TOP_SELLING_PRODUCT, getTopSellingProducts);
  yield (0, _effects.takeLatest)(actions.DELETE_ITEMS, deleteProducts);
  yield (0, _effects.takeLatest)(actions.CART_PRODUCTS_RECOMMENDATION, cartProductsRecommendation);
  yield (0, _effects.takeEvery)(actions.ADD_TO_CART_V2, addItemToCartV2);
  yield (0, _effects.takeEvery)(actions.UPDATE_PRODUCT_QUANTITY_V2, updateProductQuantityV2);
  yield (0, _effects.takeLatest)(actions.DELETE_ITEMS_V2, deleteProductsV2);
  yield (0, _effects.takeEvery)(actions.GET_CART_V2, getCartInfoV2);
  yield (0, _effects.takeEvery)(actions.FBT_ADD_TO_CART, addFBTToCart);
  yield (0, _effects.takeLatest)(actions.GET_CART_MARKETING_BANNER, getCartMarketingBanner);
  yield (0, _effects.takeLatest)(actions.GET_CART_FILLERS, getCartFillers);
  yield (0, _effects.takeEvery)(actions.ASTER_ONLINE_ADD_TO_CART, addONLINEASTERToCart);

  /**
   * New Cart Saga generators to yeild response for request
   * **/
  yield (0, _effects.takeEvery)(actions.GET_COMMON_SERVICE_CART_DATA, getCommonServiceCartData);
  yield (0, _effects.takeEvery)(actions.GET_CART_DETAILS, getCartDetails);
  yield (0, _effects.takeEvery)(actions.ADD_ITEMS_TO_CART, addItemsToCart);
  yield (0, _effects.takeEvery)(actions.UPDATE_ITEMS_IN_CART, updateItemsInCart);
  yield (0, _effects.takeEvery)(actions.REMOVE_ITEM_FROM_CART, removeItemsFromCart);
  yield (0, _effects.takeEvery)(actions.REMOVE_MULTIPLE_ITEMS_FROM_CART, removeMultipleItemsFromCart);
  yield (0, _effects.takeEvery)(actions.MERGE_CART_DETAILS, mergeCartDetails);
  yield (0, _effects.takeEvery)(actions.CREATE_RX_CART, createRxCart);
  yield (0, _effects.takeEvery)(actions.RESET_RX_CART, resetRxCart);
  yield (0, _effects.takeEvery)(actions.UPDATE_USER_CART_DATA, updateUserCartData);
}